import {
  DELETE_FILTER_INTERIOR,
  SET_FILTER_INTERIOR,
} from '@/store/redux/actions/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';

import { RESET_FILTER_INTERIOR } from './../../../../../actions/pages/pcp/filters/interior/index';

export interface InteriorFilterStateProps {
  interiorType: string[];
  interiorColor: string[];
  filterCount: number;
}

export const InitialInteriorFilterState: InteriorFilterStateProps = {
  interiorType: [],
  interiorColor: [],
  filterCount: 0,
};

const InteriorFilterState = (
  state: InteriorFilterStateProps = InitialInteriorFilterState,
  action: IReduxActionProps
) => {
  switch (action.type) {
    case SET_FILTER_INTERIOR: {
      const newValues = {
        interiorType: action.payload?.interiorType ?? [],
        interiorColor: action.payload?.interiorColor ?? [],
      };

      return {
        ...newValues,
        filterCount:
          newValues.interiorType.length + newValues.interiorColor.length,
      };
    }
    case DELETE_FILTER_INTERIOR: {
      const interiorPayloadKey: keyof Omit<
        InteriorFilterStateProps,
        'filterCount'
      > =
        (action.payload?.interiorType && 'interiorType') ||
        (action.payload?.interiorColor && 'interiorColor');

      const interiorPayloadValue =
        action.payload?.interiorType || action.payload?.interiorColor;

      const index = state[interiorPayloadKey].indexOf(interiorPayloadValue);

      const interiorValues = [
        ...state[interiorPayloadKey].slice(0, index),
        ...state[interiorPayloadKey].slice(index + 1),
      ];

      return {
        ...state,
        [interiorPayloadKey]: interiorValues,
        filterCount: state.filterCount - 1,
      };
    }
    case RESET_FILTER_INTERIOR:
      return InitialInteriorFilterState;
    default:
      return state;
  }
};

export default InteriorFilterState;
